import { apiGet, apiPost, apiUpdate } from "../http";
export default {
  async getPlatformsAPI() {
    return await apiGet("api/platforms");
  },
  async getPlatformUploadHistoryAPI() {
    return await apiGet("api/platformUpload/history");
  },
  async getPlatformUploadHistorySuccessAPI(id) {
    return await apiGet(`api/platformUpload/history/successful/${id}`);
  },
  async getPlatformUploadHistoryFailedAPI(id) {
    return await apiGet(`api/platformUpload/history/failed/${id}`);
  },
  async resolveProductPlatformAPI(data) {
    return await apiUpdate(`api/platformUpload/productEdit`, data);
  },
  async saveTranslationsOnPlatformsAPI(data) {
    return await apiPost(`api/platformUpload/saveTranslations`, data);
  },
  async getMissingPlatformParametersAPI(data) {
    return await apiPost(`api/platformUpload/missingCategoryCodes`, data);
  },
  async uploadProductsAPI(data) {
    return await apiPost(`api/platformUpload/upload`, data);
  },
  async exportToPiguLtAPI(data) {
    return await apiPost(`api/pigult/xml`, data);
  },
};
